import { LocateableStop } from "~/api/resources/Itineraries";
import { Listing } from "~/api/resources/Listings";

export type ListingPreview = Pick<
  Listing,
  "name" | "city" | "short_description" | "website" | "lead_media"
>;

export const listingPreviewFromStop = (
  stop: LocateableStop,
): ListingPreview => ({
  name: stop.name,
  city: stop.city,
  short_description: stop.short_description,
  website: stop.website2,
  lead_media: stop.lead_media,
});
